import { render, staticRenderFns } from "./SurgeryConsent.vue?vue&type=template&id=04a583ea&scoped=true"
import script from "./SurgeryConsent.vue?vue&type=script&lang=js"
export * from "./SurgeryConsent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04a583ea",
  null
  
)

export default component.exports